// eslint-disable-next-line camelcase
const meta_keys = {
  title: 'meta-title',
  description: 'meta-description',
  keywords: 'meta-keywords',
};

export const Meta = (section = '') => ({
  head() {
    const result = { meta: [] };
    const sectionObject = this.$t(`${section}`);

    if (Object.keys(sectionObject).length) {
      if (sectionObject[meta_keys.title]) {
        result.title = sectionObject[meta_keys.title];
      }

      if (sectionObject[meta_keys.description]) {
        result.meta.push({
          name: 'description',
          hid: 'description',
          content: sectionObject[meta_keys.description],
        });
      }

      if (sectionObject[meta_keys.keywords]) {
        result.meta.push({
          name: 'keywords',
          hid: 'keywords',
          content: sectionObject[meta_keys.keywords],
        });
      }
    }

    return result;
  },
});
